<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle"><a id="page_vii"></a><strong>Shadows made the mountains dark, and you, you didn’t find the way.</strong></p>
<p class="att">—LINE FROM “SYNNØVE’S SONG,” LYRICS BY BJ. BJØRNSON</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm01.vue?43ea4358